<div class="workflow-execution-container">
  <!-- Title -->
  <div class="page-title">
    <h2 *ngIf="prUrl">PR URL = <a [href]="prUrl" target="_blank" class="pr-link">{{ prUrl }}</a></h2>
    <h2 *ngIf="!prUrl && commitId">Commit = {{ commitId }}</h2>
  </div>

  <!-- Divider -->
  <mat-divider></mat-divider>

  <!-- Details Section -->
  <div class="details-section">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 class="details-title">DETAILS</h3>
      <div class="icon-container" (click)="refreshData()">
        <div class="refresh" matTooltip="Refresh">
          <mat-icon>refresh</mat-icon>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="error-message" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- HTML Table - Direct rendering with innerHTML -->
    <div *ngIf="!errorMessage && paginatedTableHtml" class="table-wrapper">
      <div class="table-container" [innerHTML]="paginatedTableHtml"></div>
      
      <!-- Paginator -->
      <mat-paginator 
        fxLayout="row" 
        fxLayoutAlign="end center"
        [length]="totalEvents"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="onPageChange($event)"
        showFirstLastButtons
        aria-label="Select page of workflow events">
      </mat-paginator>
    </div>

    <!-- No Data Message -->
    <div *ngIf="!isLoading && !errorMessage && !paginatedTableHtml" class="no-data-message">
      No workflow execution history available
    </div>
  </div>
</div>
